const EyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
  <path d="M1.33331 8.00004C1.33331 8.00004 3.33331 3.33337 7.99998 3.33337C12.6666 3.33337 14.6666 8.00004 14.6666 8.00004C14.6666 8.00004 12.6666 12.6667 7.99998 12.6667C3.33331 12.6667 1.33331 8.00004 1.33331 8.00004Z" stroke="#3E5066" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M7.99998 10C9.10455 10 9.99998 9.10461 9.99998 8.00004C9.99998 6.89547 9.10455 6.00004 7.99998 6.00004C6.89541 6.00004 5.99998 6.89547 5.99998 8.00004C5.99998 9.10461 6.89541 10 7.99998 10Z" stroke="#3E5066" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default EyeIcon;
